export default "__VITE_ASSET__D4FUouyP__"